import * as Sentry from '@sentry/gatsby';

const isProduction =
  process.env.NODE_ENV && process.env.NODE_ENV.includes('production');

if (isProduction) {
  Sentry.init({
    dsn: 'https://916f8fbb3722498ab4d2bfd4be40b7a7@sentry.io/1783764',
    environment: process.env.NODE_ENV,
  });
}
